import Model from "./base/model";

class quoteContract extends Model{
  resourceName() {
    return "quote_contracts";
  }

  fields() {
    return {
      path: "",
      name: "",
      checked: "",
      updated_at: "",
    }
  }
}

export default new quoteContract();
